<template>
  <div class="RMPE-Layout RMPE-Layout-ImageLeft">
    <div class="columns">
      <div
        class=" column RMPE-Layout-BackgroundImage"
      >
        <img
          class="RMPE-Layout-Image"
          :src="image"
          alt=""
        >
      </div>

      <div class=" column RMPE-Layout-Field">
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
import LayoutMixin from '../mixins/layout-mixin';

export default {
  mixins: [LayoutMixin],

  props: {},

  data() {
    return {};
  },

  computed: {},

  methods: {},
};
</script>

<style scoped lang="scss">
.columns{
  display: flex;
}

.RMPE-Layout-ImageLeft {
  display: flex;
}

.RMPE-Layout-BackgroundImage {
  padding: 0;
  width: 100%;
  height: 40vh;
  order: -1;
  @media screen and (min-width: 960px) {
    width: 50%;
    height: auto;
    order: unset;
  }
}

.RMPE-Layout-Field {
  .field{
    margin-left: auto;
    margin-right: auto;
  }
  @media screen and (min-width: 960px) {
    width: 50%;
    padding-left: 48px;
    padding-right: 48px;
  }
}

</style>
